import { useState, useEffect, useCallback } from 'react';
import SaktiAttendanceAuditApiService from '../services/saktiAttendanceAuditApiService';
import { SaktiLivenessAuditFilters, SaktiLivenessAuditItem } from '../types';

export function useSaktiLivenessAudit(initialFilters: SaktiLivenessAuditFilters) {
  const [filters, setFilters] = useState<SaktiLivenessAuditFilters>(initialFilters);
  const [audits, setAudits] = useState<SaktiLivenessAuditItem[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchAudits = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await SaktiAttendanceAuditApiService.getLivenessAudits(filters);
      setAudits(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Gagal memuat audit liveness');
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchAudits();
  }, [fetchAudits]);

  return {
    filters,
    setFilters,
    audits,
    loading,
    error,
    refetch: fetchAudits,
  };
}
